/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { BufferAttribute, BufferGeometry } from 'three';
/**
 * Creates a buffergeometry from pointclouds
 */
export class PointCloud {
    static createFromAccessor(accessor, colormap) {
        const geometry = new BufferGeometry();
        const numOfElements = accessor.getNumberOfElements();
        const vertices = new Float32Array(numOfElements * 3);
        if (colormap == null) {
            const iBuffer = new Float32Array(numOfElements);
            let idx = 0;
            let iBufferIdx = 0;
            accessor.callForAllElements((x, y, z, i) => {
                iBuffer[iBufferIdx++] = i;
                vertices[idx++] = x;
                vertices[idx++] = y;
                vertices[idx++] = z;
            });
            geometry.addAttribute('preliminaryColor', new BufferAttribute(iBuffer, 1));
        }
        else {
            const colors = new Float32Array(numOfElements * 3);
            let idx = 0;
            accessor.callForAllElements((x, y, z, i) => {
                const c = colormap[Math.floor(i * (colormap.length - 1))];
                colors[idx] = c.r;
                vertices[idx++] = x;
                colors[idx] = c.g;
                vertices[idx++] = y;
                colors[idx] = c.b;
                vertices[idx++] = z;
            });
            geometry.addAttribute('color', new BufferAttribute(colors, 3));
        }
        geometry.addAttribute('position', new BufferAttribute(vertices, 3));
        return geometry;
    }
    static createFromArray(arr) {
        const geometry = new BufferGeometry();
        const vertices = Float32Array.from(arr);
        geometry.addAttribute('position', new BufferAttribute(vertices, 3));
        return geometry;
    }
}
//# sourceMappingURL=PointCloud.js.map